const getCurrencyData = () => {
  return [
    "$",
    "₹",
    "£",
    "€",
    "¢",
    "₡",
    "Lek",
    "؋",
    "ƒ",
    "₼ ",
    "Br",
    "BZ$",
    "$b",
    "KM",
    "P",
    "лв",
    "R$",
    "៛",
    "¥",
    "kn",
    "₱",
    "Kč",
    "kr",
    "RD$",
    "Q",
    "L",
    "Ft",
    "Rp",
    "﷼",
    "₪",
    "J$",
    "₩",
    "₭",
    "ден",
    "RM",
    "₨",
    "₮",
    "MT",
    "C$",
    "₦",
    "B/.",
    "Gs",
    "S/.",
    "zł",
    "lei",
    "₽",
    "Дин.",
    "S",
    "R",
    "CHF",
    "฿",
    "TT$",
    "₴",
    "$U",
    "Bs",
    "₫",
    "Z$"
  ]
}

module.exports = {
  getCurrencyData
}
